'use client';

import {
  CUSTOMER_CURRENCIES,
  CURRENCY_SYMBOLS,
  getCurrencyOptionLabel,
  isCustomerCurrency,
  type CustomerCurrency,
} from '@/config/currency';
import { useCurrency } from '@/lib/context/CurrencyContext';

export const CurrencySelector = () => {
  const { currentCurrency, setCurrency } = useCurrency();

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const next = event.target.value;
    if (isCustomerCurrency(next)) {
      setCurrency(next);
    }
  };

  return (
    <div className="relative flex shrink-0 items-center">
      <label htmlFor="header-currency" className="sr-only">
        Currency
      </label>
      {/* Mobile collapsed control: symbol only. Options keep full "USD $" labels. */}
      <span
        aria-hidden
        className="pointer-events-none absolute left-2 top-1/2 z-[1] -translate-y-1/2 font-inter text-sm font-normal text-gray-200 sm:hidden"
      >
        {CURRENCY_SYMBOLS[currentCurrency]}
      </span>
      <select
        id="header-currency"
        name="currency"
        value={currentCurrency}
        onChange={handleChange}
        aria-label="Currency"
        className="max-w-[2.75rem] cursor-pointer appearance-none rounded border border-gray-700 bg-transparent py-1.5 pl-2 pr-6 font-inter text-sm font-normal text-transparent outline-none transition-colors hover:border-gray-500 focus-visible:border-primary-400 focus-visible:ring-1 focus-visible:ring-primary-400 sm:max-w-none sm:text-gray-200 sm:hover:text-white"
      >
        {CUSTOMER_CURRENCIES.map((currency: CustomerCurrency) => (
          <option key={currency} value={currency} className="bg-gray-900 text-gray-100">
            {getCurrencyOptionLabel(currency)}
          </option>
        ))}
      </select>
      <span
        aria-hidden
        className="pointer-events-none absolute right-1.5 top-1/2 -translate-y-1/2 text-[10px] leading-none text-gray-400 sm:right-2"
      >
        ▾
      </span>
    </div>
  );
};
